import PropTypes from 'prop-types'

// import { CHART_LQIP } from '@aytm/app/stats/page/data-quality-report/lib/image-lqip'

import style from '@aytm/app/stats/page/data-quality-report/styles/sections/TrafficSentinel.module.scss'

// Static educational content (Figma 8345-153396). The blocked-attempts stat lives in the
// section header summary; this body explains the feature. Image is a placeholder until the
// exported asset is provided.
const BLOCKS = [
  {
    key: 'what',
    q: 'What is Traffic Sentinel?',
    a: 'Traffic Sentinel is the first line of defense, designed to control inbound traffic and prevent fraudulent participants from accessing surveys.'
  },
  {
    key: 'how',
    q: 'How does it work?',
    a: 'This technology blends device fingerprinting, SuperCookies, graph theory and network intelligence to reliably identify users and prevent fraud in digital research. It tracks devices even in private mode, maintains persistent IDs across sessions, and detects VPNs and proxies — boosting data quality while staying privacy-compliant.'
  },
  {
    key: 'why',
    q: 'Why does it matter?',
    a: 'The Sentinel filtered out traffic with responses that could have contaminated your survey data.'
  }
]

const TrafficSentinel = () => (
  <div data-testid="stat-dqr-traffic-sentinel" className={style.sentinel}>
    <img
      className={style.image}
      src="/images/data-quality/chart.jpg"
      alt="Traffic Sentinel"
      width="286"
      height="328"
      // style={{ backgroundImage: `url(${CHART_LQIP})` }}
    />
    <div className={style.content}>
      {BLOCKS.map(block => (
        <div key={block.key} data-testid={`stat-dqr-traffic-sentinel-${block.key}`} className={style.block}>
          <div className={style.q}>{block.q}</div>
          <p className={style.a}>{block.a}</p>
        </div>
      ))}
    </div>
  </div>
)

TrafficSentinel.displayName = 'TrafficSentinel'
TrafficSentinel.propTypes = { state: PropTypes.string, tier: PropTypes.string, data: PropTypes.object }
export default TrafficSentinel
